import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import MyOrder from "./myorder";
import Footer from "./Footer";
const UserOrder = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <MyOrder />
      <Footer />
    </>
  );
};

export default UserOrder;
